(ns app.front.view.project.bill-subs
  (:require
    [app.domain.fee.model :as fee-model]
    [app.front.entities :as entities]
    [app.front.view.project.bill-events :as bill-events]
    [clojure.string :as str]
    [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::bill-reversal
  :-> ::bill-events/bill-reversal)

(rf/reg-sub ::reversal-modal-open?
  :<- [::bill-reversal]
  (fn [reversal-state [_ bill-id]]
    (= (get-in reversal-state [:modal :open-for-bill]) bill-id)))

(rf/reg-sub ::available-reversal-methods
  (fn [[_ bill]]
    [(rf/subscribe [::entities/entities {:entity/type :entity.type/schedule-reversal-method-assignment
                                         :schedule-reversal-method-assignment/schedule
                                         (get-in bill [:bill/schedule :db/id])}])
     (rf/subscribe [:language])])
  (fn [[assignments lang] [_ bill]]
    (->> assignments
         (keep #(let [method      (:schedule-reversal-method-assignment/method %)
                      method-type (:bill-reversal-method/type method)]
                  (when (and (fee-model/allowed-reversal-method-type? method-type bill)
                             (not (fee-model/reversal-method-disabled? method)))
                    {:label       (fee-model/reversal-method-title method lang)
                     :description (fee-model/reversal-method-message method lang)
                     :method-id   (:db/id method)
                     :method      method})))
         (sort-by :label))))

(rf/reg-sub ::selected-reversal-method
  :<- [::bill-reversal]
  (fn [reversal-state _]
    (get-in reversal-state [:modal :selected-method])))

(rf/reg-sub ::reversal-reason
  :<- [::bill-reversal]
  (fn [reversal-state _]
    (get-in reversal-state [:modal :reason] "")))

(rf/reg-sub ::reversal-submitting?
  :<- [::bill-reversal]
  (fn [reversal-state _]
    (get-in reversal-state [:modal :submitting?] false)))

(rf/reg-sub ::can-submit-reversal?
  :<- [::selected-reversal-method]
  :<- [::reversal-reason]
  (fn [[method reason] _]
    (and (some? method)
         (not (str/blank? reason)))))
